import React from 'react';

const Offer = () => {
  return (
    <section id='offer'>
      <div className='container tc'>
        <div className='s-48'></div>
        <h3 className='title-sub'>IT-Umschulung &amp; Weiterbildung</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Wählen Sie Ihre IT-Weiterbildung: Fachinformatiker, Cyber Security oder Digital Design:
        </h4>
        <div className='s-48'></div>
        <div className='row'>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>🤖</p>
              <h3 className='title-card'>KI</h3>
              <ul className='c-list'>
                <li>KI & Maschinelles Lernen</li>
                <li>Data Science & Analytics</li>
                <li>Prompt Engineering</li>
              </ul>
              <a href='#cta' className='button pink'>
                Mehr erfahren
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>💻</p>
              <h3 className='title-card'>Tech</h3>
              <ul className='c-list'>
                <li>Softwareentwicklung & Engineering</li>
                <li>DevOps &amp; Cloud Computing</li>
                <li>Cyber Security Weiterbildung</li>
              </ul>
              <a href='#cta' className='button pink'>
                Mehr erfahren
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>🎨</p>
              <h3 className='title-card'>Non-Tech</h3>
              <ul className='c-list'>
                <li>UI/UX Design</li>
                <li>Grafik- & Webdesign</li>
                <li>Digital & Social Media Marketing</li>
              </ul>
              <a href='#cta' className='button pink'>
                Mehr erfahren
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='s-48'></div>
        </div>
      </div>
    </section>
  );
};

export { Offer };